
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { getSuppliersList } from "@/api/inquiry";
import {
  updatePackageInfoRemark,
} from "@/api/package";
import {batchDelete, deleteOne, detail, downloadShellPackage, search, upload} from "@/api/shell-package";

@Component({
  name: "ShellPackageInfoManagement",
  components: {
    Pagination,
    EditForm: () => import("./components/edit/index.vue"),
  },
})
export default class extends Vue {
  private header = {
    customerAbbr: null,
    brand: null,
    seller: null,
    saleAssistant: null,
    customerId: null,
    brandId: null,
  };
  private headerFields = [
    {label: "客人简称", key: "customerAbbr"},
    {label: "当前品牌", key: "brand"},
    {label: "销售员", key: "seller"},
    {label: "销售助理", key: "saleAssistant"}
  ];
  private showEdit = false;
  private operate = "";
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public listParam = {
    customerId: null,
    nation: null,
    brand: null,
    sellerId: null,
    seller: null,
    saleAssistant: null,
  };
  public searchForm = [
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "",
    },
    {
      label: "付款供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
    },
    {
      label: "供应商简称",
      prop: "supplierAbb",
      key: "supplierAbb",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "详情",
          code: "",
          click: "handleView",
        },
        {
          name: "编辑",
          code: "",
          click: "handleEdit",
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 150,
    },
  ] as any;

  private rowId = "";
  private customerId = "";
  private brandId = "";
  private uploadCommand = "";

  created() {
    this.header.customerAbbr = this.$route.query.customerAbbr;
    this.header.brand = this.$route.query.customerBrand;
    this.header.seller = this.$route.query.seller;
    this.header.saleAssistant = this.$route.query.saleAssistant;
    this.header.customerId = this.$route.query.customerId;
    this.header.brandId = this.$route.query.customerBrandId;
    this.customerId = this.$route.query.customerId as any;
    this.brandId = this.$route.query.customerBrandId as any;
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getList();
  }

  public listLoading: Boolean = false;
  private async getList() {
    this.listLoading = true;
    const params = {
      ...this.listParam,
      customerId: this.header.customerId,
      brandId: this.header.brandId,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    const { total, list }: any = await search(params);
    this.table.total = +total;
    this.table.list = list;
    // this.table.list.map((e,index) => {
    //   e.sn = index + 1
    // });
    this.listLoading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private async getSuppliersList(name = "") {
    this.searchForm[1].options = await getSuppliersList({ abbreviation: name }) as any;
    this.searchForm[1].options = this.searchForm[1].options.concat({id: "通用供应商", abbreviation: "通用供应商"});
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      await updatePackageInfoRemark(
        {
          customerId: item.id,
          remark: item.remark
        }
      )
        .then((res) => {
          this.confirmSuccess();
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      await this.getList();
    }
  }

  public handleCommand(command) {
    // this[command]();
    this.uploadCommand = command;
  }

  // 上传维护
  private async handleUpload(file: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let formData = new FormData();
    formData.append("file", file.file);
    formData.append("customerId", this.header.customerId);
    formData.append("brandId", this.header.brandId);
    formData.append("uploadType", this.uploadCommand);
    await upload(formData)
      .then(() => {
        loading.close();
        this.confirmSuccess();
      })
      .catch((err) => {
        loading.close();
        console.log(err);
      });
  }

  private handleSuccess() {
    this.showEdit = false;
    this.getList();
  }

  private async deleteShellPackageInfo() {
    if (!this.selectedRows.length) {
      this.$notify.error("请选择要删除的数据");
      return;
    }
    const ids = this.selectedRows.map((item) => item.id);
    const data = {shellPackageInfoIds: ids};
    this.$confirm("确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await batchDelete(data)
          .then(() => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //  删除
  public async handleDelete(scope) {
    const params = {shellPackageInfoId: scope.row.id};
    await deleteOne(params)
      .then(() => {
        this.confirmSuccess();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  public querySearch(data) {
    this.listParam = data;
    this.getList();
  }

  private details = [];

  // 新增
  private async handleCreate() {
    this.details = [];
    this.operate = "新增";
    this.showEdit = true;
  }

  // 编辑
  public async handleEdit(scope) {
    this.details = await detail({shellPackageInfoId: scope.row.id}) as any;
    this.rowId = scope.row.id;
    this.operate = "编辑";
    this.showEdit = true;
  }

  // 详情
  public async handleView(scope) {
    this.details = await detail({shellPackageInfoId: scope.row.id}) as any;
    this.operate = "详情";
    this.showEdit = true;
  }

  private confirmSuccess() {
    (this.$refs.table as any).$refs.table.clearSelection();
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }

  private async download() {
    const params = {
      customerId: this.header.customerId,
      brandId: this.header.brandId
    };
    await downloadShellPackage(params);
  }
}
